import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";

/**
 * Subscribes to the single spec bound to the given chat thread.
 *
 * Returns `{ spec: null, version: null }` when the thread has no spec
 * yet — the agent has not yet authored one via the praxis spec verbs
 * (see `apps/clawcraft/domain/praxis-commands.ts` for the canonical
 * shapes, per praxis-doctrine §6.1 single-source rule).
 */
export function useSpec({ threadId }: { threadId: Id<"threads"> }) {
  const result = useQuery(api.specs.getForThread, { threadId });
  return {
    spec: result?.spec ?? null,
    version: result?.version ?? null,
    isLoading: result === undefined,
  };
}
